<template>
    <input ref="dateRangePicker" type="text" name="daterange" />
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
export default {
    'name': 'DateTimePicker',
    data () {
        return {
            'startDate': null,
            'endDate': null,
            'minDate': null
        };
    },
    mounted () {
        $(this.$refs.dateRangePicker).daterangepicker({
            'opens': 'right',
            'locale': {
                'format': 'DD/MM/YYYY'
            },
            'autoApply': true
        }, (start, end, label) => {
            this.startDate = start;
            this.endDate = end;
        });

        this.startDate = $(this.$refs.dateRangePicker).data('daterangepicker').startDate;
        this.endDate = $(this.$refs.dateRangePicker).data('daterangepicker').endDate;
    },
    'methods': {
        setDate (start, end) {
            $(this.$refs.dateRangePicker).data('daterangepicker').setStartDate(start);
            $(this.$refs.dateRangePicker).data('daterangepicker').setEndDate(end);

            this.startDate = $(this.$refs.dateRangePicker).data('daterangepicker').startDate;
            this.endDate = $(this.$refs.dateRangePicker).data('daterangepicker').endDate;
        },
        getDates () {
            return {
                'startDate': this.startDate,
                'endDate': this.endDate
            };
        }
    }
};
</script>

<style>

</style>
